function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M79.7936 41.2692C71.1142 28.3121 72.0367 15.0306 67.8531 8.7859C63.6694 2.54118 51.2011 -8.22543 21.7412 10.5356C-7.71879 29.2966 -0.225864 49.6909 4.37776 56.5577C25.9225 88.7143 95.1673 64.2165 79.7936 41.2692Z",
  fill: "#F7F7F9"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M66.8175 37.6782V52.2217C66.8175 54.6828 64.752 56.6966 62.2276 56.6966H19.7715C17.2471 56.6966 15.1816 54.6828 15.1816 52.2217V37.6782H23.8106C24.8203 37.6782 25.7153 38.3271 25.9907 39.2668L28.4693 47.2769C28.7446 48.2166 29.6397 48.8655 30.6494 48.8655H51.3497C52.3594 48.8655 53.2545 48.2166 53.5298 47.2769L56.0084 39.2668C56.2838 38.3271 57.1788 37.6782 58.1885 37.6782H66.8175Z",
  fill: "#F3F3F1"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M66.8175 37.6782H58.1885C57.1788 37.6782 56.2838 38.3271 56.0084 39.2668L53.5298 47.2769C53.2545 48.2166 52.3594 48.8655 51.3497 48.8655H30.6494C29.6397 48.8655 28.7446 48.2166 28.4693 47.2769L25.9907 39.2668C25.7153 38.3271 24.8203 37.6782 23.8106 37.6782H15.1816L25.5088 15.3037H56.4903L66.8175 37.6782Z",
  fill: "#E7F5FE"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M58.6936 47.2769L61.1721 39.2668C61.4475 38.3271 62.3425 37.6782 63.3523 37.6782H58.1887C57.179 37.6782 56.2839 38.3271 56.0086 39.2668L53.53 47.2769C53.2546 48.2166 52.3596 48.8655 51.3499 48.8655H56.5134C57.5232 48.8655 58.4182 48.2166 58.6936 47.2769Z",
  fill: "#D5DBE1"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M20.3452 52.2217V37.6782H15.1816V52.2217C15.1816 54.6828 17.2471 56.6966 19.7715 56.6966H24.9351C22.4107 56.6966 20.3452 54.6828 20.3452 52.2217Z",
  fill: "#D5DBE1"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M25.5088 15.3037L15.1816 37.6782H20.3452L30.6724 15.3037H25.5088Z",
  fill: "#B6E2FB"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M33.6328 47.2769L31.1543 39.2668C30.8789 38.3271 29.9839 37.6782 28.9741 37.6782H23.8105C24.8203 37.6782 25.7153 38.3271 25.9907 39.2668L28.4692 47.2769C28.7446 48.2166 29.6397 48.8655 30.6494 48.8655H35.813C34.8032 48.8655 33.9082 48.2166 33.6328 47.2769Z",
  fill: "#B6E2FB"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M63.3613 10.2695C61.4634 10.2695 59.9189 8.76367 59.9189 6.9133C59.9189 5.06293 61.4634 3.55713 63.3613 3.55713C65.2592 3.55713 66.8037 5.06293 66.8037 6.9133C66.8037 8.76367 65.2592 10.2695 63.3613 10.2695ZM63.3613 5.79458C62.7279 5.79458 62.2139 6.298 62.2139 6.9133C62.2139 7.5286 62.7279 8.03203 63.3613 8.03203C63.9947 8.03203 64.5088 7.5286 64.5088 6.9133C64.5088 6.298 63.9947 5.79458 63.3613 5.79458Z",
  fill: "#75768A"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M15.855 6.50964L17.4786 4.92902L20.7258 8.09027L19.1022 9.6709L15.855 6.50964Z",
  fill: "#75768A"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M15.4453 17.1901L18.6925 14.0288L20.3161 15.6094L17.0689 18.7707L15.4453 17.1901Z",
  fill: "#75768A"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M24.7783 8.09265L28.0232 4.92899L29.6457 6.51082L26.4008 9.67448L24.7783 8.09265Z",
  fill: "#75768A"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M62.2276 58.3746H19.7715C16.2901 58.3746 13.4604 55.6158 13.4604 52.2216V37.6782C13.4604 37.441 13.5109 37.2061 13.6119 36.9891L23.9391 14.6146C24.2168 14.0127 24.8318 13.6256 25.5088 13.6256H56.4903C57.1673 13.6256 57.7823 14.0127 58.06 14.6146L68.3872 36.9891C68.4882 37.2061 68.5387 37.441 68.5387 37.6782V52.2216C68.5387 55.6158 65.709 58.3746 62.2276 58.3746ZM16.9028 38.0384V52.2216C16.9028 53.7632 18.1903 55.0184 19.7715 55.0184H62.2276C63.8088 55.0184 65.0963 53.7632 65.0963 52.2216V38.0384L55.3773 16.9818H26.6218L16.9028 38.0384Z",
  fill: "#75768A"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M51.3405 50.5435H30.6586C28.8732 50.5435 27.3264 49.4226 26.8123 47.7534L24.3499 39.7568C24.2764 39.5219 24.0515 39.3563 23.8014 39.3563H15.1816V36.0001H23.8014C25.5868 36.0001 27.1336 37.1211 27.6477 38.7902L30.1101 46.7869C30.1836 47.024 30.4085 47.1874 30.6586 47.1874H51.3405C51.5906 47.1874 51.8178 47.024 51.889 46.7869L54.3514 38.7902C54.8655 37.1211 56.41 36.0001 58.1977 36.0001H66.8175V39.3563H58.1977C57.9476 39.3563 57.7204 39.5196 57.6492 39.7568L55.1868 47.7534C54.6727 49.4226 53.1259 50.5435 51.3405 50.5435Z",
  fill: "#75768A"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M4.28101 55.0183H77.7186V58.3745H4.28101V55.0183Z",
  fill: "#75768A"
});

function SvgEmptyBox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 72,
    viewBox: "0 0 82 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyBox);
export default __webpack_public_path__ + "static/media/emptyBox.c73c2de0.svg";
export { ForwardRef as ReactComponent };